// @flow
import type { Action /* Deps */ } from './types';

export const onUsersPresence = (): Action => {
  const presence = {
    Y5O3H2IIHhZEtJevZc89NkqpEdm2: {
      '-KV_Tw5M4Wd1wDTCRpLT': {
        lastSeenAt: 1478097617366,
        user: {
          displayName: 'email@gmail.com',
          id: 'Y5O3H2IIHhZEtJevZc89NkqpEdm2',
          photoURL: '',
        },
      },
    },
  };
  return {
    type: 'ON_USERS_PRESENCE',
    payload: { presence },
  };
};

export const saveUserDone = (): Action => ({
  type: 'SAVE_USER_DONE',
});

export const epics = [];
